// extracted by mini-css-extract-plugin
export default {"create_password":"CreatePassword_create_password__xpcdg","info_text":"CreatePassword_info_text__44c5t"};